import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CamionEAD } from "app/features/selectores/index";
type Entity = Partial<models.FiltroConsultaZE>;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    session: models.Session;

}


/**
* Componente para editar un Entity
*/
export class FiltroConsultaZEComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Date = getField(kea.DateTime);
        const VehiculoZE = getField(selectores.VehiculoZE2(typeof value.idUsuarioZE === 'undefined' || value.idUsuarioZE == null
          ? 0: value.idUsuarioZE));
        const ProveedorZE = getField(selectores.UsuarioZEByUserRol);

        const UsuarioZEReadonly = this.props.session.IdUsuarioZE != null
        const VehiculoZEReadonly = this.props.session.IdChoferZE != null && this.props.session.IdVehiculoZE != null

        return (
            <div>
                {kea.autogrid(3, [
                    <ProveedorZE field="idUsuarioZE" readonly={UsuarioZEReadonly} label="Proveedor"/>,
                    <VehiculoZE field="idVehiculoZE" readonly={VehiculoZEReadonly} label="Vehículo de ZE:" />,
                    <Date field="fecha" label="Fecha:" />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaZE/filtro.tsx